if (process.env.NODE_ENV === 'production') {
  module.exports = require('./css-sides.production.js');
} else {
  module.exports = require('./css-sides.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@team-griffin/css-sides/dist/es/css-sides.js
// module id = 285
// module chunks = 0